// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{background-color:#fff}html,body{height:100%}", "",{"version":3,"sources":["webpack://./src/apps/login/root/root.component.scss"],"names":[],"mappings":"AAAA,KACE,qBAAA,CAGF,UACE,WAAA","sourcesContent":["body {\n  background-color: #FFFFFF;\n}\n\nhtml, body {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
